export const GET_RESOLUTION_REPORT_ASYNC = 'GET_RESOLUTION_REPORT_ASYNC'
export const GET_RESOLUTION_REPORT_SUCCESS = 'GET_RESOLUTION_REPORT_SUCCESS'
export const GET_RESOLUTION_REPORT_FAIL = 'GET_RESOLUTION_REPORT_FAIL'

export const GET_REQUEST_REPORT_ASYNC = 'GET_REQUEST_REPORT_ASYNC'
export const GET_REQUEST_REPORT_SUCCESS = 'GET_REQUEST_REPORT_SUCCESS'
export const GET_REQUEST_REPORT_FAIL = 'GET_REQUEST_REPORT_FAIL'
